import React, { createContext, useContext, useState } from 'react';

const ClassContext = createContext();

export const ClassProvider = ({ children }) => {
  const [myClass, setMyClass] = useState('customClass');

  const toggleClass = () => {
    setMyClass((prevClass) => (prevClass === 'customClass' ? 'sb-sidenav-toggled' : 'customClass'));
  };

  return (
    <ClassContext.Provider value={{ myClass, toggleClass }}>
      {children}
    </ClassContext.Provider>
  );
};

export const useClass = () => {
  return useContext(ClassContext);
};